module.exports = __webpack_public_path__ + "img/banner.99232f08.png";